module.exports = __webpack_public_path__ + "static/slider-4-ae7c42b4e3c9bdf6775684dbe186e693.png";